// extracted by mini-css-extract-plugin
export default {"textWrap":"MainTitle_textWrap__bS6zo","title":"MainTitle_title__8JOQw","text":"MainTitle_text__ZT47U"};